// extracted by mini-css-extract-plugin
export default {"cardHead":"ActiveCustomers_cardHead__I9mez","cardTitle":"ActiveCustomers_cardTitle__Acgu+","chart":"ActiveCustomers_chart__gHy-M"};